import { Display, MultistepForm } from "stentor-models";

export function isForm(display: Display): display is MultistepForm {
    return !!display && display["type"] === "FORM";
}
